import { createContext } from "react";

const AggregatesListContext = createContext();

export const AggregatesListProvider = ({ children, currfilterState, setCurrFilterState, filterTab, isLoading, allFilterTabs, tagsList, type  }) => {
    return (
        <AggregatesListContext.Provider value={{ currfilterState, setCurrFilterState, filterTab, isLoading, allFilterTabs, tagsList, type}}>
            {children}
        </AggregatesListContext.Provider>
    );
};
export default AggregatesListContext;
